import React, { Component } from "react";

export default class TxtMosaicViewerClass extends Component {

  parseLines(input) {
    const lines = input.split(/\r?\n/);
    const result = [];

    for (const line of lines) {
      if (!line.trim()) continue;

      const zones = line.split("\t");

      if (zones.length === 3) {
        result.push({
          timeIn: zones[0].trim(),
          timeOut: null,
          speaker: zones[1].trim(),
          text: zones[2].trim()
        });
      }
      else if (zones.length >= 4) {
        result.push({
          timeIn: zones[0].trim(),
          timeOut: zones[1].trim(),
          speaker: zones[2].trim(),
          text: zones.slice(3).join("\t").trim()
        });
      }
    }

    return result;
  }

  render() {
    const { text } = this.props;
    const lines = this.parseLines(text);

    const containerStyle = {
      background: "#11151c",
      color: "#d8dee9",
      padding: "1rem",
      borderRadius: "0.75rem",
      fontFamily: "JetBrains Mono, Fira Code, monospace",
      lineHeight: "1.5em",
      boxShadow: "0 0 10px rgba(0,0,0,0.4)",
      overflowX: "auto"
    };

    const lineStyle = {
      marginBottom: "0.35rem",
      whiteSpace: "pre-wrap"
    };

    const timeStyle = {
      color: "#7aa2f7",
      fontWeight: "bold"
    };

    const speakerStyle = {
      color: "#e0af68",
      fontWeight: "bold"
    };

    const textStyle = {
      color: "#c0caf5"
    };

    const separatorStyle = {
      color: "#565f89",
      padding: "0 0.6rem",
      fontWeight: "normal"
    };

    return (
      <div style={containerStyle}>
        {lines.map((line, i) => (
          <div key={i} style={lineStyle}>

            <span style={timeStyle}>
              {line.timeIn}
            </span>

            {line.timeOut && (
              <>
                <span style={separatorStyle}>│</span>

                <span style={timeStyle}>
                  {line.timeOut}
                </span>
              </>
            )}

            <span style={separatorStyle}>│</span>

            <span style={speakerStyle}>
              {line.speaker}
            </span>

            <span style={separatorStyle}>│</span>

            <span style={textStyle}>
              {line.text}
            </span>
            <br/>

          </div>
        ))}
      </div>
    );
  }
}